$(function() {
  // Homepage Hero + Carousel

  $('[js-carousel]').each(function() {
    $(this).flickity({
      bgLazyLoad: 1,
      prevNextButtons: false,
      draggable: false
    });
  });

  $('[js-carousel-dot]').on('click', function() {
    var index = $(this).data('slide');
    var $carousel = $(this).parent().siblings('[js-carousel]');
    $carousel.flickity('select', index);
    $(this).addClass('is-selected').attr('aria-current', 'step');
    $(this).siblings().removeClass('is-selected').removeAttr('aria-current');
  });
  // End Homepage Hero + Carousel

  // PDP
  new Shopify.OptionSelectors(
    "product-select", 
    { 
      product: window.productJSON,
      onVariantSelected: selectCallback 
    }
  );

  var selectCallback = function(variant, selector) {
    console.log(variant);
  }

  $('.selector-wrapper').each(function() {
    $(this).addClass('custom-select');
  })

  //Custom select
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
      c = document.createElement("DIV");
      c.setAttribute('data-value', selElmnt.options[j].innerHTML)
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function(e) {
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  document.addEventListener("click", closeAllSelect);

  if ($('[js-tab-button]').length === 1) {
    $('.product__display-2').addClass('is-active');
  }

  $('body').on('click', '[js-tab-button]', function(){
    if(!$(this).hasClass('is-active')) {
      var $el = $(this);
      var controls = $el.attr('aria-controls');
      $('[js-tab-button]').removeClass('is-active');
      $('[js-tab-button]').attr('aria-selected', false);
      $('[js-tab-button]').attr('aria-expanded', false);
      $el.addClass('is-active');
      $el.attr('aria-selected', true);
      $el.attr('aria-expanded', true);

      $('[js-tab-container]').each(function(){
       var $el = $(this);
       if ($el.hasClass('is-active')) {
         $el.removeClass('is-active');
         $el.attr('aria-hidden', true);
       }
       else if ($el.hasClass(controls)) {
         $el.addClass('is-active');
         $el.attr('aria-hidden', false);
       }
      })
    };

    $('video').each(function() {
      $(this).trigger('pause');
    })
  });

  var selections = $('.single-option-selector').length;
  var variant = ''

  for (var i = 0; i < selections; i++) {
    if (i == 0) {
      variant = $('#product-select-option-' + i).val();
    } else {
      variant += ' / ' + $('#product-select-option-' + i).val();
    }
  };

  $('.select-items > div').click(function() {
    variant = ''

    for (var i = 0; i < selections; i++) {
      if (i == 0) {
        variant = $('#product-select-option-' + i).val();
      } else {
        variant += '/' + $('#product-select-option-' + i).val();
      }
    };

    $('#product-select > option').each(function() {
      var optionName = $(this).text().split('-')[0].replace(/ /g,'');
      variant = variant.replace(/ /g, '');

      if (optionName === variant) {
        $(this)
          .attr('selected', 'selected')
          .siblings()
          .removeAttr('selected');

        if ($(this).data('quantity') == 0) {
          $('.product__btn').attr('disabled', 'disabled').html('Sold Out')
        } else {
          $('.product__btn').removeAttr('disabled').html('Add to bag -' + $(this).data('price'));
        }
      }
    })
  });

  if (window.productAvailable) {
    document.querySelector('[data-value="'+window.availableVariantOption1+'"]').click();
    document.querySelector('[data-value="'+window.availableVariantOption2+'"]').click();
  }else{
    console.log('product unavailable')
  }

  console.log(window.productJSON)

  $('body').on('click', '[js-accordion-header]', function(evt){
    var $el = $(this);
    if($el.attr('aria-expanded') == 'true'){
      $el.siblings().slideUp(400, function() {
        $(this).attr('aria-hidden', true);
      })

      $el.siblings('[js-accordion-content]').find('[js-accordion-header]').each(function(){
        $(this).attr('aria-expanded', false);
        $(this).siblings('[js-accordion-content]').slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        });
      })
      $el.attr('aria-expanded', false);
    } else {
      $el.parent().siblings().find('[js-accordion-content]', '[js-accordion-group]').slideUp(400, function(){
        $(this).attr('aria-hidden', true);
      });
      $el.parent().siblings().find('[js-accordion-header]', '[js-accordion-group]').attr('aria-expanded', false);
      $el.siblings('[js-accordion-content]').slideDown().attr('aria-hidden', false);
      $el.attr('aria-expanded', true);
    }
  })

  var $carousel = $('[js-product-carousel]').flickity({
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true,
    imagesLoaded: true
  });

  var $carouselNav = $('[js-product-nav-carousel]');
  var $carouselNavCells = $carouselNav.find('.product__carousel-cell');

  $('.flickity-button').click(function() {
    $('.product__carousel-cell > video').each(function() {
      $(this).trigger('pause');
    })
    
    $('.product__carousel-cell.is-selected > video').trigger('play');
  })
  
  $carouselNav.on('click', '.product__carousel-cell', function(e) {
    var index = $(e.currentTarget).index();
    $carousel.flickity('select', index);

    $('.product__carousel-cell > video').each(function() {
      $(this).trigger('pause');
    })
    
    $('.product__carousel-cell.is-selected > video').trigger('play');
  });
  
  var flkty = $carousel.data('flickity');
  var navCellHeight = $carouselNavCells.height();
  var navHeight = $carouselNav.height();
  
  $carousel.on('select.flickity', function() {
    $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
    var $selected = $carouselNavCells.eq( flkty.selectedIndex ).addClass('is-nav-selected');
    var scrollY = $selected.position().top + $carouselNav.scrollTop() - (navHeight + navCellHeight) / 2;

    $carouselNav.animate({
      scrollTop: scrollY
    });
  });
  // End PDP
});

$(function() {
  var cacheVars = {
    $window: $(window),
    $navBar: $('[js-navbar]')
  }
  //Scrollbar
  $(window).scroll(function(){
    var scroll = cacheVars.$window.scrollTop();
    if (scroll > 200) {
      cacheVars.$navBar.addClass('scrolled')
    }else{
      cacheVars.$navBar.removeClass('scrolled')
    }
  })
})

  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });